// extracted by mini-css-extract-plugin
export default {"card":"Register_card__Vohd4","outerCard":"Register_outerCard__lajed","zenImage":"Register_zenImage__g106N","mx-message-container":"Register_mx-message-container__jsJiM"};